import { Playground, PropsTable } from '@versionone/doc-components';
import { Avatar } from "../../../../../components/src/Avatar";
import { AvatarIcon, AssetIcon } from '@versionone/icons';
import { Link } from "../../../../../components/src/Link";
import { Chip } from "../../../../../components/src/Chip";
import { Conversation, Expression, NewExpression } from "../../../../../components/src/Conversation";
import { Collapsable } from "../../../../../components/src/Conversation/examples/Collapsable";
import { Reply } from "../../../../../components/src/Conversation/examples/Reply";
import { NewConversation } from "../../../../../components/src/Conversation/examples/NewConversation";
import * as React from 'react';
export default {
  Playground,
  PropsTable,
  Avatar,
  AvatarIcon,
  AssetIcon,
  Link,
  Chip,
  Conversation,
  Expression,
  NewExpression,
  Collapsable,
  Reply,
  NewConversation,
  React
};